/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

class SolvVerified extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  render = () => (
    <SvgIcon width="50px" height="8px" viewBox="0 0 14 17" className={this.props.className}>
      <g fillRule="nonzero" fill="none">
        <path
          d="M7 .628C4.914 2.087 2.747 2.872.509 2.975v6.289c0 2.94 4.437 7.13 6.496 7.13 2.058 0 6.488-4.19 6.488-7.13v-3.13-1.986-1.173C11.21 2.875 9.042 2.09 7 .628z"
          stroke="#5B6B7D"
          strokeWidth="1.016"
          fill="#FFF"
        />
        <path
          fill="#D21869"
          d="M9.402 5.013L6.485 9.38 4.773 7.288l-.896.853 2.742 3.292 3.728-5.77z"
        />
      </g>
    </SvgIcon>
  );
}

export default SolvVerified;
